import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IDCardInterface } from "src/app/features/private/portals/student/interfaces";
import { AdmissionInterface, DownloadInstalmentPDF } from "src/app/shared/interfaces";
import { CheckStudentExistResponseInterface } from "src/app/shared/interfaces/admission/check-student-exist.interface";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class GetAdmissionService {
    constructor(protected httpClient: HttpClient) {}

    getStepDetails<T>(stepNumber: number, admission: string): Observable<T> {
        return this.httpClient.get<T>(`${environment.API_URL}/admission/`, {
            params: {
                adm: admission,
                sp: stepNumber,
            },
        });
    }
    findPartialAdmissions(data: any) {
        return this.httpClient.get<AdmissionInterface[]>(`${environment.API_URL}/get-partial-admissions/`, {
            params: { ...data },
        });
    }

    findSubmitedAdmissions(data: any) {
        return this.httpClient.get<AdmissionInterface[]>(`${environment.API_URL}/get-submitted-admissions/`, {
            params: data,
        });
    }

    checkStudentExist(data: { phone: string; dob: string }) {
        return this.httpClient.get<CheckStudentExistResponseInterface>(
            `${environment.API_URL}/admission/check-student-exist/`,
            {
                params: data,
            },
        );
    }

    downloadAdmissionForm(id: string) {
        return this.httpClient.post<{ path: string }>(`${environment.API_URL}/admission-form-print/`, { id });
    }

    downloadInstalmentRecipt(data: DownloadInstalmentPDF) {
        return this.httpClient.post<{ path: string }>(`${environment.API_URL}/print-receipt/`, data);
    }

    findPartialAdmissionByAdmissionId(admissionId: string) {
        return this.httpClient.get<AdmissionInterface>(`${environment.API_URL}/get-detail-by-admissionId/`, {
            params: { id: admissionId },
        });
    }

    getAdmissionFeesData<AdmissionFeesInterface>(admission: string): Observable<AdmissionFeesInterface> {
        return this.httpClient.get<AdmissionFeesInterface>(
            `${environment.API_URL}/schools/admission-fees-instalment/${admission}/`,
        );
    }

    getIdCardData(student_id: string) {
        return this.httpClient.get<IDCardInterface>(`${environment.API_URL}/student-id-card/detail/`, {
            params: { student_id },
        });
    }
}
